/** @format */

import * as React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

const Context = React.createContext({
  reactId: null,
  history: null,
  setContextState: () => {},
});

export default Context;

export const connectContext = Target =>
  hoistNonReactStatics(
    // eslint-disable-next-line react/prefer-stateless-function
    class consumer extends React.Component {
      render() {
        return (
          <Context.Consumer>
            {context => <Target {...this.props} context={context} />}
          </Context.Consumer>
        );
      }
    },
    Target,
  );

export const connectForwardRef = Target =>
  hoistNonReactStatics(
    React.forwardRef((props, ref) => (
      <Context.Consumer>
        {context => <Target {...props} context={context} ref={ref} />}
      </Context.Consumer>
    )),
    Target,
  );
